import React, { useEffect, useRef } from 'react';
import { useKeenSlider } from 'keen-slider/react';

export default function PartnerSlider() {
  const [sliderRef, instanceRef] = useKeenSlider({
    loop: true,
    mode: 'free',
    slides: {
      perView: 3,
      spacing: 10,
    },
    breakpoints: {
      '(min-width: 768px)': {
        slides: { perView: 4, spacing: 15 },
      },
      '(min-width: 1024px)': {
        slides: { perView: 5, spacing: 20 },
      },
    },
  });

  useEffect(() => {
    let interval;
    if (instanceRef.current) {
      interval = setInterval(() => {
        instanceRef.current.next();
      }, 1500);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [instanceRef]);

const brands = [
'img/kablo.png',
'img/alcobre.png',
'img/pramcro.png',
'img/cpreylec-logo.jpg',
'img/elydan.png'
]

return (
    <div ref={sliderRef} className="keen-slider">
      {brands.map((src, i) => (
        <div className="keen-slider__slide" key={i}>
          <img src={src} alt={`Brand ${i}`} />
        </div>
      ))}
    </div>
);
}